import { Table } from '@bancobarigui/barihaus';
import { DadosDepreciacao } from '@/features/laudo/types/laudo-wizard.types';
import type { TabelaDepreciacaoProps } from './types';
import {
  useDadosCalculados,
  useSincronizarDados,
  useDadosFiltrados,
  useAlertas,
  useAmostrasComProblemas,
} from './hooks';
import { AlertasSection } from './components/AlertasSection';
import { createColumns } from './components/TabelaDepreciacaoColumns';
import * as styles from './styles';
import { ReviewFieldWrapper } from '../../../ReviewFieldWrapper';


export { VIDA_UTIL_POR_PADRAO, VIDA_UTIL_POR_TIPO } from './constants';

export function TabelaDepreciacao({ dados, onUpdate, disabled, displayIdMap }: TabelaDepreciacaoProps) {
  const dadosCalculados = useDadosCalculados(dados);

  useSincronizarDados(dadosCalculados, dados, onUpdate);

  const dadosFiltrados = useDadosFiltrados(dadosCalculados);
  const alertas = useAlertas(dadosCalculados, displayIdMap);
  const amostrasComProblemas = useAmostrasComProblemas(dadosCalculados);

  const handleInputChange = (index: number, field: keyof DadosDepreciacao, value: number | string) => {
    const novosDados = [...dados];
    novosDados[index] = {
      ...novosDados[index],
      [field]: value,
    } as DadosDepreciacao;
    onUpdate(novosDados);
  };

  const columns = createColumns(dados, dadosCalculados, handleInputChange, disabled, displayIdMap);

  return (
    <div style={styles.containerStyle}>
      <div style={styles.titleContainerStyle}>
        <ReviewFieldWrapper
          fieldPath="amostras.tabelaDepreciacao"
          fieldLabel="Tabela de Depreciação"
          stepName="Metodologia"
          linkInline={true}
        >
          <h4 style={styles.titleStyle}>Cálculo de Depreciação</h4>
        </ReviewFieldWrapper>
      </div>

      <AlertasSection alertas={alertas} />

      <Table
        dataSource={dadosFiltrados as any[]}
        columns={columns as any}
        rowKey="identificacao"
        pagination={false}
        scroll={{ x: 1400 }}
        bordered
        size="small"
        rowClassName={(record: any) => {
          if (amostrasComProblemas.has(record.identificacao)) {
            return 'row-com-problema';
          }
          return record.identificacao === 'Avaliando' ? 'row-avaliando' : '';
        }}
      />

      <style>{styles.tableStyles}</style>
    </div>
  );
}
